import { GameRoundStatusId } from '@/models/round/status/id';
import useTranslation from 'next-translate/useTranslation';
import defaultStyles from '../styles.module.scss';
import { PlayerCountProps } from './props';
import styles from './styles.module.scss';

export default function PlayerCount({
  count,
  isLoading,
  round,
  shouldShowResult,
}: PlayerCountProps) {
  const { t } = useTranslation('smash-racing');
  const isClosed =
    round?.status?.id?.toString() === GameRoundStatusId.Completed?.toString();

  return (
    <div className={styles.container}>
      {(!isClosed || !shouldShowResult) && (
        <div className={styles.container__dot} />
      )}

      <span className={defaultStyles.container__label}>
        {count} {t('players_label')}
      </span>
    </div>
  );
}
